module.exports = __webpack_public_path__ + "static/media/loginBackgroundAutumn.41a8fe0a.svg";